import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import validators from '../../utils/validators';
import Overlay from '../../forms/_common/Overlay';
import FormErrors from '../../forms/_common/FormErrors';
import RequestError from '../../forms/_common/RequestError';
import ErrorMessage from '../../forms/_common/ErrorMessage';
import SuccessMessage from '../../forms/_common/SuccessMessage';
import Form from './Form';
import DialogTemplate from '../../dialogs_common/DialogTemplate';
import Confirmation from './Confirmation';
import { useQueryMutation } from '@lore/query-connect';

Dialog.propTypes = {
  supportQuestion: PropTypes.object.isRequired
};

export default function Dialog(props) {
  const { supportQuestion } = props;

  const [data, setData] = useState({
    question: supportQuestion.data.question,
    order: supportQuestion.data.order,
    resourceTitle: supportQuestion.data.resourceTitle,
    resourceDescription: supportQuestion.data.resourceDescription,
    resourceUrl: supportQuestion.data.resourceUrl,
    staffName: supportQuestion.data.staffName,
    staffDescription: supportQuestion.data.staffDescription,
    staffSchedulingUrl: supportQuestion.data.staffSchedulingUrl,
    staffEmail: supportQuestion.data.staffEmail,
    staffAvatarUrl: supportQuestion.data.staffAvatarUrl,
    audience: supportQuestion.data.audience
  });
  const [showErrors, setShowErrors] = useState(false);

  const mutation = useQueryMutation('supportQuestion.update', supportQuestion);
  const { saving, success, error, request } = mutation;

  useEffect(() => {
    if (success) {
      // props.onClose();
      props.onSubmit && props.onSubmit(request);
    }
  }, [success]);

  function onSubmit() {
    mutation.mutate(data);
  }

  function onChange(name, value) {
    const nextData = _.merge({}, data);
    nextData[name] = value;
    setData(nextData);
  }

  return (
    <DialogTemplate className="w-screen max-w-screen-sm">
      <Overlay isVisible={saving}>
        <FormErrors data={data} validators={{
          question: [validators.isRequired],
          audience: [validators.isRequired],
          // resourceTitle: [validators.isRequired],
          // resourceDescription: [validators.isRequired],
          // resourceUrl: [validators.isRequired],
          // staffName: [validators.isRequired],
          // staffDescription: [validators.isRequired],
          // staffSchedulingUrl: [validators.isRequired],
          // staffEmail: [validators.number.isRequired],
          // staffAvatarUrl: [validators.number.isRequired]
        }}>
          {({errors, hasError}) => {
            if (success) {
              return (
                <Confirmation
                  data={data}
                  onClose={() => {
                    props.onClose();
                    setTimeout(function() {
                      props.onSubmit && props.onSubmit(request)
                    }, 300);
                  }}
                />
              );
            }

            return (
              <Form
                data={data}
                errors={errors}
                showErrors={showErrors}
                onChange={onChange}
                onSubmit={() => hasError ? setShowErrors(true) : onSubmit()}
                onClose={props.onClose}
                alert={error ? (
                  <RequestError request={request}/>
                ) : showErrors ? (
                  <ErrorMessage>
                    Please fill in all required fields.
                  </ErrorMessage>
                ) : (false && success) ? (
                  <SuccessMessage>
                    Support question updated.
                  </SuccessMessage>
                ) : null}
              />
            );
          }}
        </FormErrors>
      </Overlay>
    </DialogTemplate>
  );
};
